import * as React from 'react'
import { useState, useImperativeHandle, forwardRef } from 'react'
import style from './style.module.css'
import classnames from 'classnames'

interface ISwitchProps {
  onChange?: (show: boolean) => any
  background?: string
  defaultValue?: boolean,
  disabled?: boolean
}

export const Switch = forwardRef((props: ISwitchProps, ref) => {

  const { background, onChange, defaultValue, disabled = false } = props

  const [isOpen, setIsOpen] = useState(defaultValue ? defaultValue : false)

  const defaultBackground = background ? background : '#FFBB22'

  function switchAction() {
    if(disabled) return
    onChange && onChange(!isOpen)
    setIsOpen(!isOpen)
  }


  useImperativeHandle(ref, () => ({
    focus: () => {
      if(disabled) return
      setIsOpen(true)
    },
    blur: () => {
      if(disabled) return
      setIsOpen(false)
    }
  }), [isOpen, disabled])

  return (
    <div
      className={classnames(style['switch'], disabled ? style['disabled'] : null)}
      onClick={switchAction}
      style={{
        background: isOpen ? defaultBackground : '#ffffff'
      }}
    >
      <div
        className={classnames(
          style['switch-bar'],
          isOpen ? style['open'] : style['close']
        )}
      >
      </div>
    </div>
  )
})



// WEBPACK FOOTER //
// ../src/switch/index.tsx